export default __webpack_public_path__ + "static/media/neon_coffee@3x.6798c499.png";